// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"c51de848","958":"aaf0a8da"}[chunkId] + ".chunk.js";
};